import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Estimate = styled.div`
  max-width: 420px;
  font-size: 18px;
  padding: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(225, 225, 255, 0.09);
  border-radius: 5px;
`;
